import { getState } from "../../getState/dev";
import { getWindow } from "../../../../utils/window";
import { getSaveSumEntry } from "./sum";
import { getSberPayId } from "./sberId";
var saveSum = getSaveSumEntry({
  getWindow: getWindow,
  getState: getState
});
var sberPayId = getSberPayId({
  getWindow: getWindow,
  getState: getState
});
export var sessionStateMap = {
  saveSum: saveSum,
  sberPayId: sberPayId
};